import { either } from "ramda";
import { IPeople, IPosUser, IPerson } from "types/schedules";

function posUsersFromPeopleWithShifts(people: IPeople): IPosUser[] {
  return people.reduce((posUsers: IPosUser[], person: IPerson) => {
    if (person.shifts.length >= 1) {
      person.assignee.map((assignee: IPosUser) => posUsers.push(assignee));
    }
    return posUsers;
  }, []);
}

function posUserHasEmail(posUser: IPosUser) {
  return posUser.email.isJust();
}
function posUserHasPhone(posUser: IPosUser) {
  return posUser.phone.isJust();
}
const posUserHasContact: (posUser: IPosUser) => boolean = either(
  posUserHasEmail,
  posUserHasPhone
);

enum NotifyType {
  EMAIL_ONLY,
  SMS_ONLY,
  SMS_AND_EMAIL,
}

export {
  posUsersFromPeopleWithShifts,
  posUserHasEmail,
  posUserHasPhone,
  posUserHasContact,
  NotifyType,
};
